/** @jsxImportSource @emotion/react */
import { IClassBlock } from "src/hooks/styles";
import { css } from "@emotion/react";

type StyleParams = {
  isOpen: boolean;
  isActive: boolean;
};

export type IStyles = IClassBlock<
  [
    | "link"
    | "linkActive"
    | "linkOpen"
    | "linkClosed"
    | "icon"
    | "arrow"
    | "arrowOpen"
    | "arrowFloating"
    | "dropdown"
    | "dropdownItem"
    | "dropdownItemFull"
    | "text",
  ],
  StyleParams
>;

const styles: IStyles = {
  link: (theme) =>
    css({
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12,
      display: "flex",
      alignItems: "center",
      letterSpacing: "-0.0em",
      flexWrap: "nowrap",
      minHeight: 32,
      cursor: "pointer",
      width: "fit-content",
      transition: "all 0.2s ease",
      position: "relative",
      whiteSpace: "nowrap",
      overflow: "hidden",
      borderRadius: 8,
      fontSize: "0.875rem",
      fontWeight: 500,
      "&:hover": {
        backgroundColor: "#f3f4f6", // Tailwind gray-100 for a subtle, modern hover
        color: theme.colorPrimary,
      },
    }),
  linkActive: (theme, state) =>
    css({
      backgroundColor: "#e5e7eb", // Tailwind gray-200 for a modern active background
      color: "#334155", // Tailwind slate-700 for a modern active color
      "&:hover": {
        backgroundColor: "#f1f5f9", // Tailwind gray-100 for a modern hover on active
        color: "#0f172a", // Tailwind slate-900 for a deeper accent on hover
      },
    }),
  linkOpen: (theme, state) =>
    css({
      width: "100%",
      justifyContent: "flex-start",
    }),
  linkClosed: (theme, state) =>
    css({
      paddingLeft: 12,
      justifyContent: "center",
      paddingRight: 12,
    }),
  icon: (theme) =>
    css({
      marginRight: 12,
      opacity: 0.7,
      transition: "opacity 0.2s ease",
    }),
  arrow: (theme) =>
    css({
      marginLeft: "auto",
      marginRight: 0,
      justifySelf: "flex-end",
      transform: "rotate(0deg)",
      transition: "transform 0.2s ease",
      transformOrigin: "center",
      opacity: 0.5,
    }),
  arrowOpen: (theme) =>
    css({
      transform: "rotate(180deg)",
      opacity: 0.7,
    }),
  arrowFloating: (theme) =>
    css({
      position: "absolute",
      top: "50%",
      right: 8,
      marginTop: -6,
    }),
  dropdown: (theme) =>
    css({
      marginBottom: 1,
    }),
  dropdownItem: (theme) =>
    css({
      fontSize: "15px",
      paddingTop: 10,
      paddingBottom: 10,
      minHeight: 36,
      marginBottom: 1,
      borderRadius: 6,
      fontWeight: 500,
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#f9fafb",
      },
      svg: {
        width: 16,
        height: 16,
        opacity: 0.6,
      },
    }),
  dropdownItemFull: (theme) =>
    css({
      paddingLeft: 16,
      svg: {
        marginLeft: 10,
      },
    }),
  text: (theme) =>
    css({
      fontSize: "13px",
      fontWeight: "inherit",
      color: theme.menu.colorText,
    }),
};

export default styles;
